import { CheckCircle2, AlertCircle } from "lucide-react";
import { Link } from "react-router-dom";

const benefits = [
    "Analyse complète du profil neuro-éducatif",
    "Identification des blocages (concentration, écrans, émotions)",
    "Plan d'action basé sur neurosciences + stoïcisme + lean",
    "Résultats visibles en quelques semaines",
];

const IMG =
    "https://images.pexels.com/photos/4260637/pexels-photo-4260637.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function DiagnosticCTA() {
    return (
        <section
            id="diagnostic"
            data-testid="diagnostic-cta-section"
            className="py-24 sm:py-32 bg-ink-50/40"
        >
            <div className="container-wide grid lg:grid-cols-12 gap-12 items-center">
                <div className="lg:col-span-7">
                    <span className="eyebrow-pink">Passez à l'action</span>
                    <h2 data-testid="diagnostic-cta-title" className="display-2 mt-4">
                        Réservez votre <span className="text-brand-500">diagnostic offert</span>.
                    </h2>
                    <p className="body-lg mt-5">
                        Un appel de 30 minutes avec un expert pour analyser la situation de votre enfant et
                        vous donner un plan d'action personnalisé.
                    </p>

                    <ul className="mt-10 space-y-4">
                        {benefits.map((b) => (
                            <li
                                key={b}
                                className="flex items-start gap-3"
                            >
                                <CheckCircle2 className="h-5 w-5 text-brand-500 mt-0.5 flex-none" strokeWidth={2} />
                                <span className="text-ink-800">{b}</span>
                            </li>
                        ))}
                    </ul>

                    <div className="mt-10 flex flex-wrap items-center gap-4">
                        <Link
                            to="/diagnostic"
                            data-testid="diagnostic-cta-button"
                            className="btn-primary"
                        >
                            Réserver mon diagnostic
                        </Link>
                        <span className="inline-flex items-center gap-2 text-sm text-pinky-600">
                            <AlertCircle className="h-4 w-4" strokeWidth={2} />
                            Places limitées cette semaine
                        </span>
                    </div>
                </div>

                <div className="lg:col-span-5">
                    <div className="relative rounded-[2rem] overflow-hidden ring-soft-brand">
                        <img
                            src={IMG}
                            alt="Enfant concentré sur ses devoirs"
                            data-testid="diagnostic-cta-image"
                            className="w-full h-[460px] object-cover"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
}
